export const es = {
  title: {
    main: "PROMPT",
    sub: "NINJA",
    remote: "CONTROL",
  },
  menu: {
    home: "Inicio",
    features: "Características",
    pricing: "Precios",
    backToHome: "Volver a Inicio",
    validate: "Validar",
    validateLicense: "Validar Licencia",
    start: "Empezar",
    startHint: "Pulsa PLAY para empezar",
    startHintShort: "Pulsa PLAY",
  },
  common: {
    sync: "Sincronizar",
    refresh: "Actualizar",
    loading: "Cargando...",
    error: "Algo salió mal",
    back: "Volver",
    next: "Siguiente",
    save: "Guardar",
    cancel: "Cancelar",
    more: "Más opciones...",
    less: "Menos",
    delete: "Delete",
    app_name: "PromptNinja",
  },
  landing: {
    meta: {
      title: "⭐ PromptNinja Teleprompter gratuito Online P2P, móvil y portátil",
      description: "El teleprompter online GRATIS más rápido. Funciona en PC, portátiles y como teleprompter para móviles o iPhone. P2P, sin retardo y sin necesidad de instalar aplicaciones.",
    },
    hero: {
      headline: "Teleprompter Online GRATIS. Graba mirando a la cámara, sin trabarte en el texto.",
      subheadline:
        "El texto avanza a tu ritmo. Controla con el celular o por voz. Sin apps, sin complicaciones.",
      cta: "🚀 Prueba Gratis Ahora",
      startHint: "Comienza Aquí",
      ctaSecondary: "▶️ Ver Cómo Funciona",
      versionLive: "Versión 2.0 Online",
      userCount: "1.247",
      activeCreators: "Creadores activos",
      freeTrial: "Prueba gratis",
      zeroSetup: "Cero Configuración. Sin Instalación.",
      offlineBadge: "Funciona Offline",
      privacyBadge: "Privacidad Total",
      smallphrase: "Sin registro • Funciona directo en el navegador • Offline después de instalar",
      p2pSection: {
        headline: "Tu red local es el túnel. Cero retraso es la regla.",
        subheadline: "Olvida el 'delay' de 3 segundos de las apps comunes. Con tecnología WebRTC P2P, lo que tocas en el celular sucede en la pantalla en el mismo milisegundo.",
        badge: "⚡ Latencia < 10ms",
      },
      privacySection: {
        headline: "Tus datos son tuyos. Y solo tuyos.",
        subheadline: "Sin cuentas, sin servidores, sin nube. Lo que escribes en PromptNinja nunca sale de tu dispositivo. Privacidad por diseño, no por promesa.",
        badge: "🔒 Cero Rastreo",
      },
      pwaSection: {
        headline: "Una app que no ocupa memoria.",
        subheadline: "Instala PromptNinja como una aplicación nativa. Funciona sin conexión, en pantalla completa y carga al instante.",
        cta: "📱 Instalar App en Móvil",
        guideCta: "Cómo instalar en iPhone/Android",
      },
    },
    problemSolution: {
      title: 'Basta de <span class="line-through text-red-500">frustración</span> al grabar videos',
      before: {
        title: "Antes",
        items: [
          "😩 Olvidar el texto a mitad del video y tener que regrabar todo",
          "😤 Perder horas pausando y ajustando el guion manualmente",
          "🏃 Te levantaste 15 veces para pausar/continuar el texto",
          "🤬 Probar soluciones caseras que no funcionan bien",
          "💸 Gastar dinero en apps o equipos que se traban o complican",
          "📱 Descargar apps llenas de logins, anuncios o lag",
        ],
      },
      after: {
        title: "Ahora",
        items: [
          "🎯 Hablar mirando directo a la cámara, con naturalidad",
          "📱 Controlar play, pausa y velocidad desde el celular (cero retraso)",
          "🗣️ El texto sigue tu voz automáticamente",
          "🔒 Todo privado: tus guiones quedan solo en tu dispositivo",
          "🌍 Funciona offline, en cualquier lugar (hasta sin internet)",
          "⏱️ Graba más videos en menos tiempo, sin regrabar",
        ],
      },
    },
    howItWorks: {
      title: "Tan simple que hasta tu abuela puede usarlo",
      step1: {
        title: "Pega tu guion",
        desc: "Escribe o pega el texto de tu presentación en la notebook",
      },
      step2: {
        title: "Escanea el QR Code",
        desc: "Apunta la cámara del celular. Conexión automática en 2 segundos",
      },
      step3: {
        title: "Graba como un PRO",
        desc: "Controla la velocidad, pausa, vuelve al inicio. Todo por el celular",
      },
      cta: "Probar Ahora (Gratis)",
    },
    comparison: {
      title: "¿Por qué PromptNinja?",
      subtitle: "Comparación honesta con otras soluciones",
      columns: {
        ninja: "PromptNinja",
        paid: "Apps Pagas",
        hardware: "Hardware",
        free: "Sitios Gratis",
      },
      rows: {
        remote: "Control Remoto",
        offline: "Funciona Offline",
        privacy: "Privacidad Total",
        latency: "Latencia",
        price: "Costo Inicial",
      },
      values: {
        ninja: {
          remote: "Celular",
          offline: "Sí",
          privacy: "P2P",
          latency: "<10ms",
          price: "Gratis / $19",
        },
        paid: {
          remote: "No",
          offline: "No",
          privacy: "Cloud",
          latency: "~100ms",
          price: "$ 15/año",
        },
        hardware: {
          remote: "Físico",
          offline: "Sí",
          privacy: "Sí",
          latency: "<5ms",
          price: "$ 100+",
        },
        free: {
          remote: "No",
          offline: "No",
          privacy: "Rastrean",
          latency: ">500ms",
          price: "Gratis c/ Ads",
        },
      },
    },
    features: {
      title: "Características",
      subtitle: "Todo lo que necesitas para un teleprompter profesional",
      badges: {
        free: "GRATIS",
        pro: "PRO",
      },
      sync: {
        title: "Sincronización Instantánea",
        desc: "Lo que ves en la PC aparece en el celular al instante.",
      },
      offline: {
        title: "Modo Offline",
        desc: "Funciona sin internet gracias a la tecnología PWA.",
      },
      privacy: {
        title: "Privacidad Primero",
        desc: "Tus guiones nunca salen de tu dispositivo.",
      },
      noApp: {
        title: "Sin App",
        desc: "No necesitas instalar nada. Funciona en el navegador.",
      },
      voice: {
        title: "Función PRO: Control por Voz",
        desc: "Desbloquea el poder del manos libres. El guion avanza a tu ritmo de voz. Prueba la versión gratuita.",
        cta: "Desbloquear Función PRO 🎤",
      },
      musician: {
        title: "Modo Músico",
        desc: "Muestra letras y acordes perfectamente alineados. Ideal para músicos que necesitan seguir acordes y letras durante presentaciones.",
        cta: "Más Información sobre el modo Música",
        cta2: "Acceder al Modo Músico",
      },
      obs: {
        title: "Integración con OBS Studio",
        desc: "Conéctate directamente a OBS vía WebSocket. Automatiza tus grabaciones y cambia de escenas de forma nativa sin salir del teleprompter.",
      },
      themes: {
        title: "Temas Visuales",
        desc: "Modos Oscuro, Claro, Matrix, Alto Contraste y Chroma Key (verde/azul) para grabaciones profesionales con fondo removible.",
      },
      pip: {
        title: "Modo Picture-in-Picture",
        desc: "Mantén el teleprompter siempre visible en una ventana flotante mientras trabajas en otras aplicaciones.",
      },
      recording: {
        title: "Grabación de Audio",
        desc: "Graba la narración de tu guion y descarga el audio para revisión, edición o respaldo de tu contenido.",
      },
      pacing: {
        title: "Calculadora de Tiempo",
        desc: "Calcula el tiempo estimado de lectura de tu guion (WPM). Ajusta el texto para 60 segundos (TikTok/Reels) o 5 minutos (YouTube). Produce contenido optimizado para cada plataforma.",
      },
      shortcuts: {
        title: "Atajos de Teclado",
        desc: "Control total con el teclado, o usa comandos de texto como STOP y PAUSE para control automático en el guion.",
      },
      bilingual: {
        title: "Nuevo: Modo Bilingüe",
        desc: "Visualiza dos idiomas lado a lado. Perfecto para aprender nuevos idiomas o para presentaciones internacionales. Usa el control de voz para rastrear el idioma de tu elección.",
        cta: "Conocer el Modo Bilingüe 🌐",
      },
      focus: {
        title: "Enfoque Dinámico",
        desc:
          "Línea de enfoque dinámico: El resaltado inteligente sigue tu lectura, asegurando que nunca pierdas el hilo.",
      },
      master: {
        title: "Gestión de Teleprompters",
        desc:
          "Gestiona varios teleprompters desde un punto central. Ideal para eventos con varios presentadores.",
      },
    },
    pricing: {
      title: "Precio Simple y Honesto",
      subtitle: "Prueba gratis, actualiza cuando quieras",
      free: {
        title: "Gratis",
        desc: "Para probar y validar",
        price: "$ 0",
        period: "/siempre",
        cta: "Empezar Gratis",
        features: ["20 minutos por sesión", "Sesiones ilimitadas", "Control remoto total", "Todos los temas", "Integración OBS (Básico)"],

        missing: ["Sesiones sin límite de tiempo", "Control por voz", "Atajos personalizados", "Integración OBS", "Gestión de múltiples teleprompter"],
      },
      pro: {
        badge: "🔥 PRECIO DE LANZAMIENTO",
        title: "PRO Vitalicio",
        desc: "Pago único, tuyo para siempre",
        price: "€ 19",
        originalPrice: "$ 49",
        priceNote: "Luego $ 3/mes o $ 49 vitalicio",
        cta: "🚀 Garantizar Acceso Vitalicio",
        timer: "⏰ Precio válido solo para los primeros 500 usuarios",
        features: [
          "Sesiones ilimitadas (sin tiempo)",
          "Sin marca de agua",
          "Múltiples controles remotos (equipos)",
          "Control por voz",
          "Soporte prioritario",
          "Soporte MIDI para controladores físicos",
          "Acceso anticipado a funciones",
          "Personalizar Atajos de Teclado",
          "Integración OBS Nativa (WebSocket)",
          "Gestión de múltiples teleprompter para eventos",
        ],
      },
      paymentInfo: "💳 Pago único vía Tarjeta. \n🔒 Garantía de 7 días.",
      // Keep old keys for backward compatibility
      lifetime: "Vitalicio",
      oneTime: "pago único",
      limitedOffer: "Oferta Limitada",
      conversionNotice: "El valor final será convertido a tu moneda local al finalizar la compra.",
    },
    faq: {
      title: "Preguntas Frecuentes",
      items: [
        {
          q: "¿Necesito instalar alguna app?",
          a: "¡No! Funciona 100% en el navegador. Abre en la notebook, escanea con el celular, y listo. Es una PWA, así que PUEDES instalarla si quieres.",
        },
        {
          q: "¿Funciona sin internet?",
          a: "¡Sí! La conexión es P2P. Si ambos están en la misma red Wi-Fi o si ya abriste la app antes, funciona offline.",
        },
        {
          q: "¿Dónde se guardan mis datos?",
          a: "No. Utilizamos tecnología P2P para mantener tus datos y scripts localmente en tus dispositivos. Tu privacidad está garantizada.",
        },
        {
          q: "¿Qué pasa después de 20 minutos en la versión gratis?",
          a: "Aparece una invitación para actualizar. Puedes iniciar una nueva sesión sin límites diarios.",
        },
        {
          q: "¿En qué navegador funciona?",
          a: "Chrome, Edge, Safari y Firefox. Recomendamos Chrome para mejor compatibilidad.",
        },
        {
          q: "¿Y si no me gusta?",
          a: "Garantía de 7 días. Devolvemos el 100% sin preguntas.",
        },
      ],
    },
    finalCta: {
      title: "¿Listo para grabar como un profesional?",
      subtitle: "Únete a los creadores que ya dejaron de regrabar 15 veces el mismo video",
      ctaPrimary: "Empezar Gratis (20 min)",
      ctaSecondary: "Ver Precios",
      footer: "Sin tarjeta de crédito. Sin instalación. Sin vueltas.",
    },
  },
  status: {
    disconnected: "DESCONECTADO",
    connecting: "CONECTANDO...",
    connected: "CONECTADO",
    error: "ERROR DE RED",
  },
  host: {
    startPrompter: "Iniciar Teleprompter",
    editText: "Editar Guion",
    mirror: "Espejar",
    mirrorV: "Espejar Verticalmente",
    remoteConnect: "Conectar Control Remoto",
    scanInstruction: "Escanea el QR para Controlar",
    generatingId: "Generando Link...",
    idLabel: "ID de Sesión:",
    editorPlaceholder: "Pega o escribe tu guion aquí...",
    musicEditorPlaceholder: `🎵 Pega tus acordes o letras aquí...
    
[Am]      [F]
Letra y acordes
[C]       [G]
Perfectamente alineados`,
    localhostWarning: "Atención: Localhost detectado.",
    offlineWarning: "¡Estás offline! El teleprompter funciona normalmente, pero la inicialización del control remoto P2P requiere conexión a internet.",
    openRemoteTab: "Abrir Control Remoto (Nueva Pestaña)",
    copyLink: "Copiar Link",
    linkCopied: "¡Copiado!",
    connectionLost: "Conexión Perdida",
    watermark: "PromptNinja - Versión Gratuita",
    exit: "Salir",
    controls: {
      play: "Reproducir",
      pause: "Pausar",
      reset: "Reiniciar",
      speed: "Velocidad",
      margin: "Margen",
      size: "Tamaño Texto",
      timer: "Temporizador",
      caps: "Mayúsculas",
      voice: "Control de Voz",
      focusLine: "Línea de Foco",
      theme: "Tema Visual",
      fontSize: "Tamaño Fuente",
      fontWeight: "Espessura da Fonte",
      isMirrored: "Espejar Horizontalmente",
      display: "Visualización",
      chroma: "Chroma Key",
      record: "Grabar",
      voiceLanguage: "Idioma de Voz",
      stopRecord: "Detener Grabación",
      downloadRecord: "Descargar Grabación",
      recordNew: "Grabar Nuevo",
      fontConfig: "Configurar Fonte",
      appearance: "Apariencia",
      prevPart: "Volver",
      nextPart: "Avanzar",
      livePreview: "Vista Previa",
      done: "Hecho",
      livePreviewHelp: "Modifique para Vista Previa",
    },
    hudLabels: {
      theme: "Tema",
      focus: "Foco",
      voice: "Voz",
      display: "Visualización",
      chroma: "Chroma Key",
    },
    themes: {
      default: "Estándar",
      ninja: "Ninja (Tema Oscuro)",
      paper: "Papel (Tema Claro)",
      contrast: "Alto Contraste",
      matrix: "Matrix",
      cyber: "Cyberpunk (Tecnológico)",
      cream: "Crema (Confort Visual)",
      chroma_green: "Chroma Key (Verde)",
      chroma_blue: "Chroma Key (Azul)",
      transparent: "Transparente",
    },
    tips: {
      title: "Consejos PRO para Edición y Rendimiento",
      desc: "Aprovecha las etiquetas para resaltar tu texto:",
      red: "Resaltado en Rojo",
      yellow: "Resaltado en Amarillo",
      green: "Resaltado en Verde",
      caps: "Usa el botón 'TT' para activar el modo MAYÚSCULAS y dar énfasis.",
      voice: "Activa el micrófono para desplazamiento automático por voz y mantén el ritmo de tu habla.",
    },
    paywall: {
      title: "Recurso Exclusivo PRO",
      unlock: "Desbloquear PRO",
      desc:
        "¡Desbloquea todo el poder de PromptNinja! Las funciones PRO incluyen control por voz, atajos de teclado y uso ilimitado.",
      cta: "Desbloquear Acceso Vitalicio PRO",
      inputPlaceholder: "Ingresa tu clave de acceso PRO...",
      button: "Activar Versión PRO",
      invalid: "Clave PRO Inválida",
      success: "¡PromptNinja PRO Activado con Éxito!",
      emptyKey: "Por favor, ingresa una clave de desbloqueo.",
      invalidKey: "Clave de desbloqueio inválida. Intenta nuevamente.",
      countdownMessage: "Regresando a la página en...",
      deviceLimit: "Límite de dispositivos alcanzado (12 dispositivos). Si cambiaste de aparato o formateaste tu PC, contacta al soporte para resetear tu acceso.",
      notFound: "Clave no encontrada. Verifica si la escribiste correctamente o revisa tu correo de Kiwify (incluyendo spam).",
      contactSupport: "Contactar Soporte (WhatsApp)",
      trialButton: "Probar Modo PRO por 24 horas",
      trialActive: "Modo PRO (Trial) Activo",
      close: "Cerrar",
      maybeLater: "Quizás después",
      freeAlternativeTitle: "¡Usa GRATIS y Ayúdanos!",
      leaveReviewCta: "⭐ Continuar Usando Gratis y Dejar 5 Estrellas en Google",
      feedbackQuestion: "¿Tienes críticas o sugerencias?",
      faltam: "Faltan",
      feedbackAction: "Danos tu opinión",
      trialExpiredTitle: "¡Ninja por un día!",
      trialExpiredDesc: "¡Esperamos que tu día Ninja haya sido productivo! Tus configuraciones han sido guardadas, pero los recursos Pro ahora están bloqueados. Asegura el acceso de por vida para seguir evolucionando.",
    },
    voice: {
      notSupported: "Tu navegador no soporta control por voz",
    },
    masterMode: "Gestión de múltiples teleprompter",
    masterPanel: "Ingrese al Panel de Control",
    editor: {
      highlight: "Resaltado",
      musicianMode: "Modo Músico",
      bilingualMode: "Modo Bilingue",
      bold: "Negrita (Ctrl+B)",
      italic: "Itálico (Ctrl+I)",
      underline: "Subrayado (Ctrl+U)",
    },
    autocomplete: {
      title: "Comandos Sugeridos",
      navigate: "Navegar",
      select: "Selecionar",
      results: "resultados",
      suggestions: {
        speed: { label: "VELOCIDAD", desc: "Cambia la velocidad (Ej: [SPEED 5])" },
        pause: { label: "PAUSA", desc: "Pausa por X segundos (Ex: [PAUSE 5])" },
        stop: { label: "PARAR", desc: "Detiene el desplazamiento (Ex: [STOP])" },
        loop_start: { label: "LOOP INICIO", desc: "Inicia un tramo de repetición" },
        loop_end: { label: "LOOP FIN", desc: "Termina el bucle con X vueltas (Ex: [LOOP 5])" },
        part: { label: "PARTE", desc: "Marca una división del guion" },
        bpm: { label: "BPM", desc: "Ajusta el BPM (Ej: [BPM 120] o [BPM AUTO])" },
        count: { label: "CONTEO", desc: "Temporizador regresivo (Ej: [COUNT 10])" },
        rest: { label: "DESCANSO", desc: "Tiempo de intervalo (Ej: [REST 15])" },
      }
    },
    defaultText: `Bienvenido a PromptNinja.

Haz clic en REPRODUCIR y lee mientras miras a la cámara.

El teleprompter definitivo para creadores de contenido.

1. Escanea el código QR para conectar.
2. Controla la velocidad de desplazamiento con facilidad.
3. Usa el Trackpad para navegación intuitiva.

<r>ATENCIÓN:</r>
Usa las etiquetas de color para resaltar momentos importantes en tu guion.
<y>Este texto está en amarillo para énfasis leve.</y>
<g>Y este en verde para señalar calma o una transición suave.</g>

¡Pega tu guion aquí y personaliza tu experiencia para empezar a brillar!`,
    ndi: {
      toggleLabel: "Salida NDI (OBS/Vmix)",
      toggleDesc: "Transmisión vía Captura de Pantalla",
      tutorial: {
        title: "Guía de Configuración NDI",
        step1: "Abre <b>vdo.ninja</b> en una nueva pestaña.",
        step2: "Selecciona 'Remote Screenshare'.",
        step3: "En OBS, agrega 'Browser Source' con el enlace de VDO.",
        step4: "Alternativa: Usa 'Captura de Ventana' de OBS directamente.",
        cleanMode: "Modo Limpio (Sin HUD)",
        vingesterConfig: "Para NDI nativo, usa la app Vingester.app",
        openVdo: "Abrir VDO.Ninja",
        close: "Cerrar",
        cleanModeBtn: "Reiniciar en Modo Limpio (?hud=0)"
      }
    }
  },
  bilingual: {
    mode: "Modo Bilingüe",
    primaryLanguage: "Idioma Principal (Idioma 1)",
    secondaryLanguage: "Idioma Secundário (Idioma 2)",
    primaryPlaceholder: "Pega el texto en el idioma principal aquí...",
    secondaryPlaceholder: "Pega el texto en el idioma secundario aquí...",
    voiceTrackLabel: "Control de Voz Rastrea:",
    voiceTrackPrimary: "Idioma Principal",
    voiceTrackSecondary: "Idioma Secundario",
    description: "Muestra dos textos lado a lado para aprender idiomas o presentaciones multilingües.",
    columnInfo: "Ambas columnas se mostrarán una al lado de la otra con una división 50/50.",
    alignmentTip: "Consejo: Usa [ALIGN]palabra[/ALIGN] en ambos textos para sincronizar palabras específicas durante el desplazamiento.",
    trackLanguage: "Rastrear este idioma (Control por Voz)",
    tracking: "El control por voz está habilitado en esta pestaña.",
    landscapeTip: "💡 Para la mejor experiencia en móvil, gira a modo paisaje (horizontal)",
    languages: {
      pt: "Portugués",
      en: "Inglés",
      es: "Español",
      it: "Italiano",
      fr: "Francés",
      de: "Alemán",
      ja: "Japonés",
      zh: "Chino",
      other: "Otro",
      auto: "Automático (Idioma del Sitio)"
    },
  },
  pacing: {
    title: "Calculadora de Tiempo de Lectura",
    wordCount: "Palabras",
    estimatedTime: "Tiempo Estimado",
    wpmLabel: "Palabras por Minuto (WPM)",
    slow: "Lento (120 WPM)",
    medium: "Medio (150 WPM)",
    fast: "Rápido (180 WPM)",
    totalWithPauses: {
      title: "Tempo Total",
      details: "Sin pausas -",
      pauses: "Con pausas -",
    },
    platforms: {
      title: "Recomendaciones por Plataforma",
      tiktok: "TikTok/Reels (60s)",
      youtube: "YouTube (5 min)",
    },
    suggestions: {
      tooLong: "Tu guion es largo. Considera reducir a ~{{words}} palabras.",
      tooShort: "Tu guion es corto. Considera agregar ~{{words}} palabras.",
      perfect: "¡Perfecto!",
    },
    custom: {
      title: "WPM Personalizado",
      label: "Tu Velocidad (WPM)",
      result: "Tiempo Estimado",
    },
    button: "Calcular Tiempo",
  },
  paywall: {
    title: "Personaizar Atajos de Teclado",
    unlock: "Desbloquear PRO",
  },
  remote: {
    connecting: "Buscando Host...",
    targetId: "Target: {{id}}",
    touchArea: "TRACKPAD",
    speed: "Velocidad",
    reset: "Reiniciar",
    start: "Inicio",
    pause: "Pausa",
    stop: "Stop",
    theme: "Tema",
    language: "Idioma",
    bilingualEditTitle: "Edición Bloqueada",
    bilingualEditWarning: "La edición está desactivada en modo bilingüe. Use la computadora principal.",
    scanError: "Error al acceder a la cámara. Verifica los permisos o si estás usando HTTPS.",
    iosMicGuidance: {
      title: "Consejo para iOS/Safari",
      description: "Para evitar avisos repetidos de permiso, toca el icono 'AA' en la barra de direcciones, selecciona 'Configuración del sitio web' o '...', y cambia 'Micrófono' a 'Permitir'.",
      button: "Cómo configurar",
      step1: "Toca el icono 'AA' en la barra de direcciones",
      step2: "Selecciona 'Configuración del sitio web' o '...' y cambia 'Micrófono' a 'Permitir'",
    },
    voicePermission: {
      title: "Micrófono Bloqueado",
      description: "Safari bloqueó el acceso. Haz clic abajo para intentar reactivar o sigue el consejo en los ajustes.",
      action: "Intentar de nuevo",
    },
    proFeature: "Característica PRO",
  },
  share: {
    button: "Compartir PromptNinja",
    title: "¡Comparte PromptNinja!",
    text: "¡Mis videos quedaron perfectos! 🎬 Descubrí PromptNinja - teleprompter online GRATIS, P2P y sin retrasos. ¡Uso mi celular como control remoto!",
    success: "¡Gracias por compartir! ❤️",
    notSupported: "Compartir no disponible en este navegador",
    cardTitle: "Compartir",
    cardDescription: "¿Te gustó PromptNinja? ¡Comparte con amigos y ayuda a otros creadores!",
  },
  tutorial: {
    tips: {
      title: "Tips Pro",
      tip1: "Usa control por voz para manos libres.",
      tip2: "Escanea el QR para controlar desde tu teléfono.",
    },
    title: "PromptNinja: Guía Rápida",
    overview: {
      title: "Resumen",
      description: "PromptNinja transforma tu navegador en un estudio de teleprompter.",
    },
    howToUse: {
      title: "Cómo Usar",
      step1: {
        title: "Escribe tu Guion",
        description: "Escribe o pega tu texto. Usa etiquetas <r>texto</r> para color.",
      },
      step2: {
        title: "Conecta tu Teléfono",
        description: "Escanea el código QR para usarlo como control remoto.",
      },
      step3: {
        title: "Inicia la Presentación",
        description: "Usa el control remoto para manejar la velocidad y el texto.",
      },
    },
    advancedFeatures: {
      title: "Funciones Avanzadas",
      voiceControl: {
        title: "Control de Voz",
        description: "El texto avanza automáticamente al hablar.",
      },
      themes: {
        title: "Temas",
        description: "Personaliza los colores.",
      },
      focusMode: {
        title: "Modo Foco",
        description: "Resalta la línea actual.",
      },
      noControls: {
        title: "Modo Sin Controles",
        description:
          "Para una experiencia más limpia, activa el modo sin controles. La interfaz desaparece, pero mantienes el control vía celular o atajos.",
      },
      musicianMode: {
        title: "Modo Músico",
        description:
          "Perfecto para acordes y letras. Este modo conserva el formato original y evita saltos de línea no deseados, ideal para tocar y cantar.",
      },
      bilingualMode: {
        title: "Modo Bilingüe",
        description:
          "Muestra dos textos uno al lado del otro. Ideal para aprender idiomas o presentaciones multilingües. Incluye seguimiento de control por voz seleccionable.",
      },
    },
    commands: {
      title: "Comandos de Texto Inteligentes",
      subtitle: "Automatiza tu guion con comandos entre corchetes",
      speed: {
        title: "Velocidad Dinámica",
        desc: "Cambia la velocidad de desplazamiento automáticamente.",
        example: "[SPEED 5]",
      },
      loop: {
        title: "Bucle / Repetición",
        desc: "Crea bucles para ejercicios o estribillos. Repite la sección entre START y la cantidad definida.",
        example: "[LOOP START] ... [LOOP 3]",
      },
      pause: {
        title: "Pausa Programada",
        desc: "Pausa el desplazamiento por X segundos y reanuda automáticamente.",
        example: "[PAUSE 5]",
      },
      stop: {
        title: "Parar",
        desc: "Detiene el desplazamiento automaticamente.",
        example: "[STOP]",
      },
      next: {
        title: "Próximo ou Anterior",
        desc: "Avança ou volta para a próxima parte. Use atalhos de teclado ( →, ← ).",
        example: "[PART X] [SLIDE X]",
      },
      count: {
        title: "Conteo",
        desc: "Conteo de repeticiones. Ideal para ejercicios (hecho para integración con control de voz).",
        example: "[COUNT 10]",
      },
      rest: {
        title: "Descanso",
        desc: "Descanso por X segundos e retoma automaticamente. Ideal para ejercicios.",
        example: "[REST 5]",
      },
    },
  },
  script: {
    manager: "Scripts",
    yourScripts: "Tus guiones",
    untitled: "Guion sin titulo",
    new: "Nuevo guion",
    rename: "Renombrar guion",
    deleteConfirm: "¿Estás seguro de eliminar este guion?",
    trash: "Basura",
    emptyTrash: "Tu basura está vacia",
    restore: "Restaurar",
    permanentlyDelete: "Eliminar permanentemente",
    autoCleanupNote: "Los guiones se eliminan automaticamente después de 14 dias",
  },
  footer: {
    copyright: "PromptNinja. Todos los derechos reservados.",
    links: {
      resources: "Recursos",
      oratory: "Consejos de Oratoria",
      alternatives: "Alternativas",
      whatIs: "Que Es Teleprompter",
    },
  },
  editor: {
    findReplace: "Buscar y reemplazar",
    find: "Buscar",
    findPlaceholder: "Escriba el texto a buscar...",
    replacePlaceholder: "Escriba el texto a reemplazar...",
    replaceWith: "Reemplazar por",
    replace: "Reemplazar",
    findNext: "Buscar siguiente",
    replaceAll: "Reemplazar todo",
    undo: "Deshacer",
    matches: "resultados",
    cleanText: "Limpiar texto",
    removeLineBreaks: "Eliminar saltos de línea",
  },
  thankYou: {
    title: "¡Gracias por tu compra!",
    subtitle:
      "Tu pago ha sido confirmado con éxito. Ahora estás a un paso de desbloquear todo el poder de PromptNinja Pro.",
    success: {
      title: "¡PromptNinja Pro Activado!",
      message: "Tu cuenta ha sido actualizada con éxito. Disfruta de todas las funciones ilimitadas.",
      button: "Empezar a Usar Ahora",
    },
    activation: {
      title: "Activar tu licencia",
      description:
        "Ingresa el código de activación que recibiste en tu correo (o en la página de confirmación de Kiwify).",
      label: "Código de Activación",
      placeholder: "INGRESA TU CÓDIGO AQUÍ",
      button: "Activar PromptNinja Pro",
      validating: "Validando...",
      skip: "Saltar activación e ir a la App Gratuita",
      error: {
        invalid: "Código inválido o ya utilizado.",
        connection: "Error de conexión. Verifica tu internet e intenta nuevamente.",
      },
    },
    footer: "© {{year}} PromptNinja. Todos los derechos reservados.",
  },
  seo: {
    scripts: {
      title: "Guiones Listos para Teleprompter",
      description: "Colección completa de guiones gratuitos para tus videos.",
    },
  },
  hudless: {
    button: "Iniciar Sin Interfaz",
    tooltip: "Inicia el teleprompter sin interfaz visible. Controla vía celular o teclas.",
    showControls: "Mostrar Controles",
  },
  hotkeys: {
    title: "Atajos de Teclado",
    proDescription: "Personalizar atajos es una función PRO.",
    reset: "Restaurar Predeterminados",
    pressKey: "Presiona la tecla...",
    actions: {
      TOGGLE_PLAY: "Reproducir / Pausar",
      SPEED_UP: "Aumentar Velocidad",
      SPEED_DOWN: "Disminuir Velocidad",
      FONT_INCREASE: "Aumentar Fuente",
      FONT_DECREASE: "Disminuir Fuente",
      TOGGLE_MIRROR: "Espejar",
      TOGGLE_FLIP: "Invertir Vertical",
      TOGGLE_FOCUS: "Modo Foco",
      EXIT: "Salir",
      RESET: "Reiniciar",
      TOGGLE_HUD: "Mostrar/Ocultar Interfaz",
      TOGGLE_CAMERA: "Alternar Cámara",
      TOGGLE_WIDGET: "Mini-Ventana (PiP)",
      NEXT_PART: "Avanzar Parte",
      PREVIOUS_PART: "Volver Parte",
      FORMAT_BOLD: "Negrita",
      FORMAT_ITALIC: "Cursiva",
      FORMAT_UNDERLINE: "Subrayado",
      FORMAT_RED: "Color: Rojo",
      FORMAT_YELLOW: "Color: Amarillo",
      FORMAT_GREEN: "Color: Verde",
      FORMAT_BLUE: "Color: Azul",
    },
  },
  voice_analytics: {
    title: "Presentación Finalizada",
    congratulations: "¡Increíble! Terminaste el guion.",
    subtitle: "Aquí tienes el resumen de tu rendimiento en esta sesión:",
    duration: "Duración",
    wpm: "WPM (Velocidad)",
    accuracy: "Precisión",
    sentences: "Frases",
    close: "Cerrar Resumen",
  },
  music: {
    bpmSync: "BPM",
    backingTrackUpload: "Agregar Backing Track",
    bpmTeaser: "Auto BPM",
    hero: {
      badge: "Modo Escenario",
      headline: "Teleprompter para Músicos:",
      subHeadline: "Setlists Infinitas, Cero Lag y Control por Pedal",
      description: "Crea setlists con desplazamiento automático, sync BPM y control P2P móvil. Perfecto para bandas independientes, sin congelarse en el escenario.",
      cta: "Crea Tu Setlist Gratis Ahora",
      ctaSecondary: "Ver en Acción",
    },
    features: {
      headline: "Todo para tu Show",
      subheadline: "Herramientas esenciales para ensayos y presentaciones en vivo.",
      setlist: {
        title: "Setlists Personalizadas",
        desc: "Añade y reordena canciones libremente. Edita acordes con fuente monoespaciada para una alineación perfecta.",
      },
      offline: {
        title: "Offline PWA",
        desc: "Instala en tablet o PC. Funciona sin internet garantizando estabilidad total en el escenario.",
      },
      themes: {
        title: "Modo Nocturno (Stage Mode)",
        desc: "Fondo oscuro y letras contrastantes. Perfecto para ambientes con poca luz sin deslumbrarte.",
      },
      lyrics: {
        title: "Cero Lag P2P",
        desc: "Control remoto vía celular con respuesta instantánea. Estabilidad esencial para shows largos.",
      },
      pedal: {
        title: "Pedales y Hotkeys",
        desc: "Atajos nativos para Page Up/Down. Compatible con pedales bluetooth para control con los pies.",
      },
      bpm: {
        title: "BPM Sync",
        desc: "Desplazamiento automático al ritmo de la banda. Escucha el sonido en vivo o sincroniza con el metrónomo.",
      },
      backingSync: {
        title: "Sync con Backing Tracks",
        desc: "Marcadores y Vista previa de 15s. Sincroniza el texto con tu audio guía o pista de acompañamiento.",
      },
      voice: {
        desc: "Deja que PromptNinja pase la página por ti. El reconocimiento de voz sigue tu canto.",
      },
      pro: {
        desc: "Desbloquea MIDI personalizable, setlists infinitos y uso multidispositivo.",
      },
    },
    landing: {
      meta: {
        title: "Teleprompter Gratis para Músicos: Setlists Infinitas, BPM Auto & Sync Backing | PromptNinja Music",
        description: "El mejor teleprompter para músicos. Crea setlists, desplaza acordes y letras automáticamente con Sync de Backing Tracks y Auto BPM vía Micrófono.",
        keywords: "teleprompter para músicos, teleprompter de acordes, app de setlist, letras y acordes, desplazamiento automático, teleprompter escenario, promptninja music, backing track sync",
      },
      pwa: {
        title: "Instala en Tu Tablet de Escenario",
        subtitle: "Offline, Rápido y Sin Notificaciones.",
        cta: "Instalar App de Escenario",
      },
      faq: {
        title: "Preguntas de Músicos",
        items: [
          {
            q: "¿Cómo sincronizar con un pedal?",
            a: "PromptNinja reconoce nativamente teclas como PageUp, PageDown, Home y End que son el estándar de la mayoría de los pedales bluetooth (incluso genéricos). Solo empareja y toca.",
          },
          {
            q: "¿Funciona para setlists de más de 30 canciones?",
            a: "¡Sí! Puedes crear setlists ilimitadas. La carga es instantánea ya que todo corre localmente en tu navegador.",
          },
          {
            q: "¿Cuál es la diferencia con apps como Cube Turner?",
            a: "PromptNinja es multiplataforma (corre en cualquier lugar) y cuenta con control remoto P2P único, permitiendo que otro miembro de la banda controle la letra desde su celular si es necesario.",
          },
          {
            q: "¿Necesito internet en el show?",
            a: "No. Recomendamos cargar la página una vez con internet. Después de eso, funciona 100% offline (PWA).",
          }
        ]
      },
      cta: {
        title: "¿Listo para Tu Próximo Show?",
        subtitle: "Más de 500 músicos ya usan PromptNinja en el escenario.",
        ctaPrimary: "Prueba Gratis en el Ensayo",
        ctaSecondary: "Ver Planes PRO",
        footer: "Simple. Rápido. Hecho para músicos.",
      },
      pricing: {
        title: "PRO Vitalicio por $19",
        subtitle: "Pago único, tuyo para siempre. Enfocado en el rendimiento escénico.",
        badge: "OFERTA MÚSICO",
        features: [
          "Setlists Ilimitadas",
          "Backing Track Sync (Sin límites)",
          "Auto BPM vía Micrófono",
          "Control MIDI Personalizado",
          "Offline PWA (App de Escenario)",
          "Soporte para Pedales Bluetooth",
          "Sin Logos / Marcas de agua",
          "Acceso Vitalicio (Sin cuotas mensuales)"
        ],
        price: "$19",
        priceNote: "Precio promocional único para músicos.",
        timer: "⏰ Asegura tu lugar en el escenario con descuento"
      },
      bpmSync: "Sincronización BPM",
      bpmTeaser: "Auto-sync con micro (detecta pulsos reales) exclusivo PRO → $19 vitalicio",
      backingTrack: {
        upload: "Añadir Backing Track",
        remove: "Eliminar",
        largeFile: "Archivo demasiado grande. Límite de 50MB.",
        error: "Error al subir el audio.",
        preview: "Vista previa (10s)",
        syncActive: "Sincronización de Audio Activa",
      },
    },
    footer: {
      backToGeneral: "Volver al Teleprompter General",
    },
  },
  midi: {
    title: "Configurar MIDI",
    enabled: "Activar Modo MIDI",
    disabled: "Desactivar Modo MIDI",
    pressPedal: "Presione el pedal o tecla...",
    mapping: "Mapeo MIDI",
    actions: {
      TOGGLE_PLAY: "Reproducir / Pausar",
      NEXT_SONG: "Próxima Canción / Parte",
      PREV_SONG: "Canción / Parte Anterior",
      START_SCROLL: "Iniciar Desplazamiento",
      STOP_SCROLL: "Detener Desplazamiento",
      SPEED_UP: "Aumentar Velocidad",
      SPEED_DOWN: "Disminuir Velocidad",
      FONT_INCREASE: "Aumentar Fuente",
      FONT_DECREASE: "Disminuir Fuente",
      RESET: "Reiniciar",
      TOGGLE_MIRROR: "Espejo",
      EXIT: "Salir",
    },
    proDescription: "La conexión con pedales MIDI y OBS Studio es exclusiva para miembros PRO.",
  },

  obs: {
    title: "Integración OBS Studio",
    connect: "Conectar",
    disconnect: "Desconectar",
    statusConnected: "Conectado",
    statusDisconnected: "Desconectado",
    host: "Host / IP",
    port: "Puerto",
    password: "Contraseña",
    automation: "Automatización Ninja",
    autoRecord: "Grabar en OBS al dar Play",
    autoPlay: "Dar Play al grabar en OBS",
    errorConnection: "Error al conectar. Verifica si OBS WebSocket (v5) está activado.",
  },
  onboarding: {
    title: "¡Bienvenido a PromptNinja! 🥷",
    subtitle: "Tu viaje hacia videos impecables comienza ahora",
    cta: "Siguiente",
    finish: "¡Empezar Ahora!",
    skip: "Saltar Tour",
    steps: [
      {
        title: "Mira a la Cámara",
        desc: "Lee tu guion manteniendo un contacto visual perfecto. PromptNinja está diseñado para que hables con naturalidad, sin olvidar el texto.",
        icon: "camera"
      },
      {
        title: "Tu Celular é o Controle",
        desc: "Usa nuestro P2P con cero retraso. Escanea o código QR con tu celular y controla todo a distancia: velocidad, play y pausa.",
        icon: "remote"
      },
      {
        title: "Poder Ninja (PRO)",
        desc: "Domina el escenario con el Control de Voz, atajos personalizados y sesiones ilimitadas. Transforma tu navegador en un estudio completo.",
        icon: "pro"
      }
    ]
  },
  master: {
    title: "MASTER",
    subtitle: "Controlar múltiples teleprompters",
    exampleTitle: "Guión de ejemplo",
    exampleContent: "Bienvenido a PromptNinja Event Mode!\n\nEste es tu centro de control.",
    connectDisplay: "Conectar Display",
    idPlaceholder: "Introduce ID...",
    add: "AGREGAR",
    connectedDisplays: "DISPLAYS CONECTADOS",
    noDisplays: "No displays conectados. Agrega un ID arriba para comenzar.",
    globalControl: "CONTROL GLOBAL",
    playAll: "JUGAR TODO",
    pauseAll: "PAUSAR TODO",
    resetAll: "REINICIAR TODO",
    scriptLibrary: "LIBRERIA DE GUIONES",
    noScripts: "No scripts guardados en la base de datos local.",
    createScriptsHint: "Crea scripts para enviar a tus displays remotamente.",
    selectedScript: "Guion seleccionado",
    deployHint: "Elige los displays a los que quieres enviar este texto:",
    confirmDelete: "¿Realmente quieres eliminar esto?",
    pushAll: "ENVIAR TODO",
    editingLocal: "Editar Script Local",
    scriptTitle: "Titulo del Script",
    scriptContent: "Contenido del Script...",
    saveChanges: "GUARDAR CAMBIOS",
    limitReached: "Limitado: Solo 1 control remoto en el plan gratuito. Actualiza a Pro!",
    displayActions: {
      play: "Reproducir",
      pause: "Pausar",
      edit: "Editar",
      remove: "Eliminar",
      push: "Enviar",
    }
  }
};


